module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel"
  }, [(_vm.verified && _vm.user) ? _c('div', {
    staticClass: "panelContent"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Hi " + _vm._s(_vm.user.profile.firstname) + ".")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Please set a password for your account, then login")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_a),
      expression: "password_a"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password_a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_a = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_b),
      expression: "password_b"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.password_b)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_b = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.success) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.setPassword
    }
  }, [_vm._v("Set")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "toast toast-error",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "toast toast-success",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("Success")])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('a', {
    staticClass: "nextStep",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "icon icon-forward"
  })]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80d3a322"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/setPassword.vue
// module id = 512
// module chunks = 1